'use client';

import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';
import React from 'react';

interface LogoHomeLinkProps {
  children: React.ReactNode;
  className?: string;
}

export default function LogoHomeLink({ children, className }: LogoHomeLinkProps) {
  const pathname = usePathname();
  const router = useRouter();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (pathname === '/') {
      event.preventDefault();
      scrollToTop();
      return;
    }

    event.preventDefault();
    router.push('/', { scroll: true });
    setTimeout(scrollToTop, 80);
  };

  return (
    <Link href="/" onClick={handleClick} className={className}>
      {children}
    </Link>
  );
}
